/**
 * #793 "Buy again this design".
 *
 * Shopify's Buy again re-adds the designer variant with none of the design's
 * line properties: a keyfob with no design, which production cannot print.
 * snippets/nfckey-cart-persistence.liquid lists those bare lines; this script
 * takes them out of the cart and sends the customer to Studio, which copies
 * their paid design as "Name (N)" and opens its approval form.
 *
 * Every string shown here is our own copy or text set with textContent, never
 * HTML from a response.
 */
(function () {
    'use strict';

    var HANDLED_KEY = 'nfckey:buy-again-handled';

    function bareLines() {
        var node = document.getElementById('nfckey-bare-designer-lines');
        if (!node) return [];
        try {
            var lines = JSON.parse(node.textContent || '[]');
            return Array.isArray(lines) ? lines.filter(function (l) { return l && l.key && l.variant_id; }) : [];
        } catch (err) {
            return [];
        }
    }

    function proxyPath() {
        var app = typeof window.NfckeyResolveStudioApp === 'function'
            ? window.NfckeyResolveStudioApp(window.NfckeyStudioDefaultAppKey)
            : null;
        return app && app.proxyPath ? app.proxyPath : '';
    }

    function readHandled() {
        try {
            var seen = JSON.parse(sessionStorage.getItem(HANDLED_KEY) || '[]');
            return Array.isArray(seen) ? seen : [];
        } catch (err) {
            return [];
        }
    }

    // One redirect per line per visit: if the cart sync puts the line back
    // before the removal is recorded, it is removed again but not chased.
    function markHandled(keys) {
        try {
            var seen = readHandled().concat(keys);
            sessionStorage.setItem(HANDLED_KEY, JSON.stringify(seen.slice(-20)));
        } catch (err) { /* private mode: the redirect still happens once */ }
    }

    function removeLines(lines) {
        return Promise.all(lines.map(function (line) {
            return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: line.key, quantity: 0 })
            }).catch(function () { return null; });
        })).then(function () {
            // Let cart-persistence record the removal and the cart UI redraw.
            document.dispatchEvent(new CustomEvent('nfckey:cart-mutated'));
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
        });
    }

    function fetchCandidates(base, variantId) {
        return fetch(base + '/api/shopify/reorder/candidates?variant_id=' + encodeURIComponent(variantId), {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
        }).then(function (res) {
            if (res.status === 401) return { status: 'signed_out', candidates: [] };
            if (!res.ok) return { status: 'error', candidates: [] };
            return res.json().then(function (body) {
                return { status: 'ok', candidates: body && Array.isArray(body.candidates) ? body.candidates : [] };
            });
        }).catch(function () {
            return { status: 'error', candidates: [] };
        });
    }

    function reorderUrl(base, batchId) {
        return base + '?reorder_batch=' + encodeURIComponent(batchId);
    }

    function injectStyles() {
        if (document.getElementById('nfckey-buy-again-styles')) return;
        var style = document.createElement('style');
        style.id = 'nfckey-buy-again-styles';
        style.textContent = [
            '.nfckey-ba{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.45)}',
            '.nfckey-ba__card{background:#fff;color:#111;border-radius:16px;max-width:420px;width:100%;max-height:90vh;overflow:auto;padding:24px;box-shadow:0 20px 50px rgba(0,0,0,.25)}',
            '.nfckey-ba__title{font-size:18px;font-weight:700;margin:0 0 8px}',
            '.nfckey-ba__text{font-size:14px;line-height:1.5;margin:0 0 16px;color:#333}',
            '.nfckey-ba__list{list-style:none;margin:0 0 16px;padding:0;display:flex;flex-direction:column;gap:8px}',
            '.nfckey-ba__pick{display:block;border:1px solid #ddd;border-radius:10px;padding:12px 14px;background:#fff;color:#111;font-size:14px;text-decoration:none}',
            '.nfckey-ba__pick:hover,.nfckey-ba__pick:focus{border-color:#00c767;background:#e6faf0}',
            '.nfckey-ba__pick small{display:block;color:#666;font-size:12px;margin-top:2px}',
            '.nfckey-ba__actions{display:flex;gap:8px;justify-content:flex-end;flex-wrap:wrap}',
            '.nfckey-ba__btn{border-radius:999px;padding:10px 18px;font-size:14px;font-weight:600;cursor:pointer;text-decoration:none;border:1px solid #ddd;background:#fff;color:#111}',
            '.nfckey-ba__btn--primary{background:#008545;border-color:#008545;color:#fff}',
            '.nfckey-ba__btn--primary:hover{background:#006a38}'
        ].join('\n');
        document.head.appendChild(style);
    }

    function el(tag, className, text) {
        var node = document.createElement(tag);
        if (className) node.className = className;
        if (text) node.textContent = text;
        return node;
    }

    function linkButton(label, href, primary) {
        var a = el('a', 'nfckey-ba__btn' + (primary ? ' nfckey-ba__btn--primary' : ''), label);
        a.href = href;
        return a;
    }

    function showDialog(title, text, build) {
        injectStyles();
        var overlay = el('div', 'nfckey-ba');
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-labelledby', 'nfckey-ba-title');
        var card = el('div', 'nfckey-ba__card');
        var heading = el('h2', 'nfckey-ba__title', title);
        heading.id = 'nfckey-ba-title';
        card.appendChild(heading);
        card.appendChild(el('p', 'nfckey-ba__text', text));
        var actions = el('div', 'nfckey-ba__actions');
        build(card, actions);
        var close = el('button', 'nfckey-ba__btn', 'Close');
        close.type = 'button';
        function dismiss() {
            overlay.remove();
            document.removeEventListener('keydown', onKey);
        }
        function onKey(e) { if (e.key === 'Escape') dismiss(); }
        close.addEventListener('click', dismiss);
        overlay.addEventListener('click', function (e) { if (e.target === overlay) dismiss(); });
        document.addEventListener('keydown', onKey);
        actions.appendChild(close);
        card.appendChild(actions);
        overlay.appendChild(card);
        document.body.appendChild(overlay);
        var first = card.querySelector('a,button');
        if (first) first.focus();
    }

    function orderedLabel(iso) {
        if (!iso) return '';
        var d = new Date(iso);
        return isNaN(d.getTime()) ? '' : 'Ordered ' + d.toLocaleDateString();
    }

    function handle(base, result) {
        var candidates = result.candidates;
        if (result.status === 'ok' && candidates.length === 1) {
            window.location.assign(reorderUrl(base, candidates[0].batch_id));
            return;
        }
        if (result.status === 'ok' && candidates.length > 1) {
            showDialog(
                'Which design would you like again?',
                'Choose the design to reorder. We will open its approval form so you can sign it and add it to your cart.',
                function (card) {
                    var list = el('ul', 'nfckey-ba__list');
                    candidates.forEach(function (c) {
                        var item = el('li');
                        var pick = el('a', 'nfckey-ba__pick', c.title || 'Your design');
                        pick.href = reorderUrl(base, c.batch_id);
                        var when = orderedLabel(c.ordered_at);
                        if (when) pick.appendChild(el('small', '', when));
                        item.appendChild(pick);
                        list.appendChild(item);
                    });
                    card.appendChild(list);
                }
            );
            return;
        }
        if (result.status === 'signed_out') {
            showDialog(
                'Sign in to buy this design again',
                'A custom keyfob needs its design. Sign in, then press Buy again once more and we will bring your design back for you to approve.',
                function (card, actions) {
                    var back = window.location.pathname + window.location.search;
                    actions.appendChild(linkButton('Sign in', '/account/login?return_url=' + encodeURIComponent(back), true));
                }
            );
            return;
        }
        showDialog(
            'We removed a keyfob without a design',
            'Buy again added a custom keyfob without its design, so we took it out of your cart. Open your designs to reorder one, or start a new design.',
            function (card, actions) {
                actions.appendChild(linkButton('Open my designs', base, true));
            }
        );
    }

    function run() {
        var lines = bareLines();
        if (!lines.length) return;
        var base = proxyPath();
        var handled = readHandled();
        var fresh = lines.filter(function (l) { return handled.indexOf(l.key) === -1; });
        removeLines(lines).then(function () {
            if (!fresh.length || !base) return;
            markHandled(fresh.map(function (l) { return l.key; }));
            return fetchCandidates(base, fresh[0].variant_id).then(function (result) {
                handle(base, result);
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})();
